<template lang="pug">
v-main
  v-container
    v-card
      v-dialog(v-model='dialogConfirmResetLogo' max-width='400')
        v-card
          h2(style="padding:1rem; text-align:center") Are you sure?
          v-card-text
            p(style="margin:0; text-align:center") Do you really want to delete this logo?
            p(style="margin:0; text-align:center") This process cannot be undone.
          v-card-actions()
            v-spacer
            div(style="display:flex; width:100%")
              v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogConfirmResetLogo = false')
                | No
              v-btn(style="background:#fc7676;color:#fff; flex:1;margin:.3rem" text='' @click='resetLogo(); dialogConfirmResetLogo = false')
                | Yes
      v-toolbar.elevation-0
        v-toolbar-title Edit Business Unit
      v-divider
      v-card-text
        v-form.my-2(v-model="valid" validate-on="input")
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Business Unit Name 
            v-col(cols="5")
              v-text-field(v-model="name", label="Name", disabled)
            
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Business Unit Code 
            v-col(cols="5")
              v-text-field(v-model="code", label="Code", disabled)

          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Business Unit Logo
            v-col(cols="9")
              div(style="display: flex; margin-bottom:1.5rem")
                img(height="90px" width="auto" :src="actualLogo")
                v-btn(x-small :disabled="disabledReset" @click="dialogConfirmResetLogo=true" style="margin: auto 1rem; padding: .4rem; color: rgb(255, 255, 255); background: #fc7676;") Reset Logo

          v-row(no-gutters)
            v-col(cols="3") 
              p(style="margin:0; padding:0 1rem" color="black") Upload Logo
              p(style="margin:0; padding:0 1rem; color: var(--notif-alert, #FB8C00); font-family: Roboto;font-size: 10px;font-style: italic;font-weight: 400;") Please click button update to save logo
              
            v-col(cols="5")
              v-file-input(
                v-model="prev_logo",
                :rules="rules",
                accept="image/*",
                label="Upload Logo"
                @change="Preview_image()"
              )
              img(v-if="prev_logo" height="90px" width="auto" :src="url_logo")

          v-row(no-gutters v-if="$store.state.dataUsers.role == 'admin'")
            v-col(cols="3") 
              v-subheader(color="black") Tagline
            v-col(cols="5")
              v-text-field(v-model="tagline" label="Tagline")

          v-row(no-gutters v-if="$store.state.dataUsers.role == 'admin'")
            v-col(cols="3") 
              v-subheader Position Logo
            v-col(cols="5")
              v-radio-group(v-model="logo_position", row)
                v-radio(label="Left", value="left")
                v-radio(label="Center", value="center")
                v-radio(label="Right", value="right")

          v-row(no-gutters, v-if="$store.state.dataUsers.role == 'super_user'")
            v-col(cols="3") 
              v-subheader Status
            v-col(cols="5")
              v-radio-group(v-model="is_active", row)
                v-radio(label="Active", value="active")
                v-radio(label="Non Active", value="nonactive")

          v-row(no-gutters v-if="$store.state.dataUsers.role == 'admin'")
            v-col(cols="3") 
              v-subheader(color="black") Show Business Unit Name
            v-col(cols="5")
              v-checkbox(v-model="show_name" label="Business Unit Name")

          v-row(no-gutters v-if="$store.state.dataUsers.role == 'admin'")
            v-col(cols="3") 
              v-subheader(color="black") Show Business Unit Tagline
            v-col(cols="5")
              v-checkbox(v-model="show_tagline" label="Tagline" :disabled="!tagline")
          
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Max Total Approver IM
            v-col(cols="5")
              v-text-field(type="number" v-model="max_approver" label="Maximum number of approver allowed per IM (set 0 for unlimited)" :rules="positiveNumRules")

          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Notification to Creator
            v-col(cols="5")
              v-checkbox(v-model="notif_creator" label="Send a notification to creator every 2 days")
          
          //- v-row(no-gutters v-if="notif_creator")
          //-   v-col(cols="3") 
          //-     v-subheader(color="black") Set Notification Time
          //-   v-col(cols="5")
          //-     v-select(
          //-       :items="notif_creator_time_opts"
          //-       v-model="notif_creator_time"
          //-       label="Time to send the notification"
          //-       persistent-hint
          //-     )

          v-card-actions.my-8
            v-btn(class="elevation-0 custom__padding-btn" @click="$router.push('/data-bu')") Back
            v-btn(
              class="custom__padding-btn elevation-0"
              dark
              color="blue-secondary"
              @click="update()"
              :disabled="!valid"
            ) Update
            PreviewLogo(
              :item="dataPreview" :lg="url_logo" :pv="prev_logo"
            )

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import PreviewLogo from "@/components/PreviewLogo.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "Data Master Edit",
  components: {
    PreviewLogo
  },
  data: () => ({
    actualLogo: '',
    dialogConfirmResetLogo:false,
    is_active: "",
    name: "",
    code: "",
    prev_logo: null,
    original_logo: "",
    logo: null,
    url_logo: "",
    tagline: null,
    logo_position: "left",
    show_tagline: false,
    max_approver: 0,
    notif_creator: false,
    // notif_creator_time: '',
    // notif_creator_time_opts: [
    //   {
    //     name: "09:00 AM",
    //     value: "9"
    //   },
    //   {
    //     name: "10:00 AM",
    //     value: "10"
    //   },
    //   {
    //     name: "11:00 AM",
    //     value: "11"
    //   }
    // ],
    show_name: false,
    valid: false,
    rules: [
      (value) =>
        !value ||
        value.size < 1000000 ||
        "File size exceeds the limit ! (Maximum 1 MB)",
    ],
    positiveNumRules: [(v) => !v || /^\d+$/.test(v) || "It should be zero or any positive number"],
    overlay: false,
    dataPreview: {
      code: null,
      bu_name: null,
      logo: null,
      logo_position: "left",
      tagline: null,
      show_name: false,
      show_tagline: false,
      // actualLogo:'',
    },
  }),
  mounted() {
    this.getData(true);
  },
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    dataPreviews: function() {
      return this.dataPreview.tagline = "test"
    },

    disabledReset: function() {
      return this.actualLogo.includes('base64')
    }
  },
  watch: {
    prev_logo() {
      this.dataPreview.logo = this.url_logo
    },
    logo_position() {
      this.dataPreview.logo_position = this.logo_position
    },
    tagline() {
      this.dataPreview.tagline = this.tagline
    },
    show_name() {
      this.dataPreview.show_name = this.show_name
    },
    show_tagline() {
      this.dataPreview.show_tagline = this.show_tagline
    },
    // notif_creator(v) {
    //   if (v) {
    //     this.notif_creator_time = this.notif_creator_time_opts[0];
    //   } else {
    //     this.notif_creator_time = ''
    //   }
    // }
  },
  methods: {
    resetLogo() {
      if (typeof this.tagline == "string" && (this.tagline.toLowerCase() === "undefined" || this.tagline.toLowerCase() === "null")) return this.$toasted.error("Incorrect tagline format.", { icon : 'error'})
      this.overlay = true;
      let token = localStorage.getItem("token");

      let formData = new FormData();
      let statusActive = this.is_active == "active" ? true : false;

      formData.append("tagline", this.tagline ? `${this.tagline}` : null)
      formData.append("is_active", statusActive);
      formData.append("logo_align", this.logo_position);
      formData.append("is_show_name", this.show_name);
      formData.append("is_show_tagline", this.show_tagline);
      formData.append("max_approver", this.max_approver);
      formData.append("notif_creator", this.notif_creator);
      // formData.append("notif_creator_time", this.notif_creator_time);
      formData.append("logo", "reset");

      const config = {
        method: "put",
        url:
          process.env.VUE_APP_API +
          `/business-unit/edit/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }

      axios(config)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$toasted.error("Reset Logo Success");
            // return this.$router.push("/data-bu");
            return this.getData(false);
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.log(err)
          this.$toasted.error(err.response.data.message);
        });
    },
    getData(isInit) {
      this.overlay = true;
      let token = localStorage.getItem("token");
      axios
        .get(
          process.env.VUE_APP_API +
            `/business-unit/detail/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log('resresresresresresresresresresresresresres\n',res)
          // !this.prev_logo ? this.prev_logo = res.data.logo : null
          this.overlay = false;
          this.name = res.data.name;
          this.code = res.data.bu_code;
          this.is_active = res.data.is_active == true ? "active" : "nonactive";
          if (isInit) this.url_logo = res.data.logo ? res.data.logo : require('../assets/no-image.jpeg');
          this.original_logo = res.data.logo ? res.data.logo : require('../assets/no-image.jpeg');
          this.tagline = res.data.tagline;
          this.logo_position = res.data.hasOwnProperty('logo_align') ? res.data.logo_align : "left";
          this.show_name = res.data.is_show_name ? res.data.is_show_name : false
          this.show_tagline = res.data.is_show_tagline ? res.data.is_show_tagline : false
          this.max_approver = res.data.max_approver ? res.data.max_approver : 0;
          this.notif_creator = res.data.notif_creator ? res.data.notif_creator : false,
          // this.notif_creator_time = res.data.notif_creator_time ? res.data.notif_creator_time : '',
          this.dataPreview.code = res.data.bu_code
          this.dataPreview.logo = res.data.logo ? res.data.logo : require('../assets/no-image.jpeg');
          this.dataPreview.bu_name = res.data.name
          // this.dataPreview.actualLogo = res.data.logo ? res.data.logo : require('../assets/no-image.jpeg');
          this.actualLogo = res.data.logo ? res.data.logo : require('../assets/no-image.jpeg');
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err, { icon: "error" });
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    },
    update() {
      if (typeof this.tagline == "string" && (this.tagline.toLowerCase() === "undefined" || this.tagline.toLowerCase() === "null")) return this.$toasted.error("Incorrect tagline format.", { icon : 'error'})
      this.overlay = true;
      let token = localStorage.getItem("token");
      let formData = new FormData();
      let statusActive = this.is_active == "active" ? true : false;

      formData.append("tagline", this.tagline ? `${this.tagline}` : null)
      formData.append("is_active", statusActive);
      formData.append("logo_align", this.logo_position);
      formData.append("is_show_name", this.show_name || this.show_name === false ? this.show_name: '');
      formData.append("is_show_tagline", this.show_tagline || this.show_name === false? this.show_tagline: '');
      formData.append("max_approver", this.max_approver);
      formData.append("notif_creator", this.notif_creator);
      // formData.append("notif_creator_time", this.notif_creator_time);

      if (this.prev_logo) {
        formData.append("logo", this.prev_logo);
      } else if (this.logo && this.prev_logo === undefined) {
        formData.append("logo", this.logo);
      } else {
        formData.append("logo", "");
      }

      const config = {
        method: "put",
        url:
          process.env.VUE_APP_API +
          `/business-unit/edit/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };

      axios(config)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$toasted.success("Update data success");
            return this.$router.push("/data-bu");
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.message);
        });
    },
    Preview_image() {
      if (this.prev_logo) {
        this.url_logo = URL.createObjectURL(this.prev_logo)
        this.original_logo = this.prev_logo
        this.logo = this.prev_logo
      } else {
        this.logo = this.original_logo
      }
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div.v-input__prepend-outer {
  display: none !important;
}

div.v-image__image {
  width: 150px;
  height: 150px;
}

div.v-responsive__sizer {
  padding-bottom: 0;
}

.v-image {
  width: 150px;
  height: 150px;
}
</style>